import React from 'react'
import SkeletonLoader from 'src/components/common/skeletonLoading'
import { LayoutCardsColumns } from '../Retencion.styles'
import Dropdown from 'src/components/common/Dropdown/Dropdown'
import { formatDate } from 'src/helpers/formatDate'

const UserData = ({ loading, data }) => {



    if (loading) return (
        <>
            <SkeletonLoader width='254px' height='20px' count={3} />
            <SkeletonLoader width='180px' height='20px' count={2} />
            <SkeletonLoader width='200px' height='20px' count={3} />
            <SkeletonLoader width='117px' height='20px' />
        </>
    )

    const { fullname, user_id, phone_contact, phone_whatsapp, email_contact, email, created, user_type, user_size, campaign } = data
    const newData = new Date(created);
    return (
        <LayoutCardsColumns>
            <div className='containerLabel gap-10'>
                <span className="label">Nombre:</span>
                <b>{fullname}</b>
            </div>
            <div className='containerLabel gap-10'>
                <span className="label">Número:</span>
                <b>{phone_contact}</b>
            </div>
            <div className='containerLabel gap-10'>
                <span className="label">Whatsapp:</span>
                <b>{phone_whatsapp}</b>
            </div>
            <div className='containerLabel gap-10'>
                <span className="label">Correo:</span>
                {email_contact || email}
            </div>
            <div className='containerLabel gap-10'>
                <span className="label">ID:</span>
                {user_id}
            </div>
            <div className={`containerLabel gap-10`}>
                <span className="label">Registro:</span>
                <b>{formatDate(newData, 'No registrado')}</b>
            </div>
            <div className={`containerLabel gap-10`}>
                <span className="label">Tipo:</span>
                {
                    user_type &&
                    <Dropdown
                        colorSelect='grey-light'
                        isDisabled={true}
                        messageTag={user_type}
                    />
                }
            </div>
            <div className={`containerLabel gap-10`}>
                <span className="label">Tamaño:</span>
                {
                    user_size &&
                    <Dropdown
                        colorSelect='grey-light'
                        isDisabled={true}
                        messageTag={user_size}
                    />
                }
            </div>
            {
                campaign &&
                <div className='containerLabel gap-10'>
                    <span className="label">Fuente:</span>

                    <Dropdown
                        colorSelect='grey-light'
                        isDisabled={true}
                        messageTag={campaign}
                    />
                </div>
            }
        </LayoutCardsColumns>
    )
}

export default UserData